import { atom } from "jotai";
import {atomWithStorage} from "jotai/utils";

export const userAtom = atomWithStorage("user", null)
export const userTokenAtom=atomWithStorage("token","")